import { AccordionItem } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/accordion-item/AccordionItem";
import { OpenInNewOutlined as OpenInNew24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./BuyingGuidesAccordion.module.scss";
import sharedStyles from "../../ProductAccordion.module.scss";
import { Link } from "../../../../types/prodcatBaseTypes";
import { useState } from "react";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
type Props = {
  links: Link[];
  open: boolean | undefined;
};

export function BuyingGuidesAccordionUI({ links, open }: Props) {
  const [isOpen, setIsOpen] = useState(open);
  if (links.length < 1) {
    return null;
  }
  return (
    <ProductAccordionWithMonetateEvents name="Useful Guides" open={isOpen}>
      <AccordionItem
        className={styles["product-accordion__item"]}
        data-testid="accordion:buyingguides"
        header={<h2 className={sharedStyles.accordionTitle}>Useful guides</h2>}
        isOpen={open}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        <ul className={styles.buyingGuides}>
          {links.map(({ linkUrl, text }) => (
            <li key={linkUrl} className={styles.buyingGuide}>
              <span className={styles.buyingGuideName}>{text}</span>
              {/* <a href={linkUrl} target="_blank" rel="noreferrer">
              View the guide
              <OpenInNew24PxOutlinedIcon />
            </a> */}
              <UnderlinedButton
                className={styles.externalButton}
                tag="a"
                target="_blank"
                rel="noreferrer"
                href={linkUrl}
              >
                View the guide
                <OpenInNew24PxOutlinedIcon size="medium" />
              </UnderlinedButton>
            </li>
          ))}
        </ul>
      </AccordionItem>
    </ProductAccordionWithMonetateEvents>
  );
}
